import {useMutation} from '@apollo/client/react';
import {Question} from '@cp/model';
import {CHECK_QUESTION_WITH_RULES} from '../sharedQueries';

export function useCheckQuestionWithRules() {
  const [checkQuestionWithRulesMutation, {loading, error}] = useMutation<
    {checkQuestionWithRules: Question},
    {moduleId: string; questionId: string}
  >(CHECK_QUESTION_WITH_RULES);

  /**
   * Check a question using rules validation (Admin only)
   * @param moduleId
   * @param questionId
   * @returns Question if successful, otherwise undefined
   */
  const checkQuestionWithRules = async (moduleId: string, questionId: string) => {
    const result = await checkQuestionWithRulesMutation({
      variables: {moduleId, questionId},
      update: (cache, {data}) => {
        if (data?.checkQuestionWithRules) {
          // Update the question in the cache
          cache.modify({
            id: cache.identify(data.checkQuestionWithRules),
            fields: {
              status: () => data.checkQuestionWithRules.status,
              statusNote: () => data.checkQuestionWithRules.statusNote,
            },
          });

          // Also update any session that contains this question
          cache.modify({
            fields: {
              userSessions: (existingSessions = []) =>
                existingSessions.map((session: any) => {
                  if (session.questions) {
                    const updatedQuestions = session.questions.map((question: any) => {
                      if (question.id === questionId) {
                        return {
                          ...question,
                          status: data.checkQuestionWithRules.status,
                          statusNote: data.checkQuestionWithRules.statusNote,
                        };
                      }
                      return question;
                    });
                    return {
                      ...session,
                      questions: updatedQuestions,
                    };
                  }
                  return session;
                }),
            },
          });
        }
      },
    });

    return result.data?.checkQuestionWithRules;
  };

  return {
    checkQuestionWithRules,
    loading,
    error,
  };
}
